import {useTranslation} from "react-i18next";
import {faArrowUpRight, faAt, faEnvelope, faPhone} from "@fortawesome/pro-solid-svg-icons";

import {Styled} from "../MainPage.styled";
import {Contact__Values} from "../../../PageValues";

const ContactBand = () => {

    const {t} = useTranslation()

    const phone = Contact__Values.phoneNumbers[0]

    const links = [
        {
            icon: faPhone,
            label: phone,
            href: `tel:${phone.replace(/\s/g, '')}`,
            external: false
        },
        {
            icon: faEnvelope,
            label: Contact__Values.emailAddress,
            href: `mailto:${Contact__Values.emailAddress}`,
            external: false
        },
        {
            icon: faAt,
            label: Contact__Values.instagramHandle,
            href: Contact__Values.instagram,
            external: true
        }
    ]

    return (
        <Styled.ContactBand>
            <Styled.ContactPanel>
                <Styled.ContactText>
                    <Styled.Eyebrow>{t('lbl_contact')}</Styled.Eyebrow>
                    <Styled.ContactTitle>{t('lbl_cta_title')}</Styled.ContactTitle>
                    <Styled.ContactLead>{t('lbl_cta_lead')}</Styled.ContactLead>
                </Styled.ContactText>
                <Styled.ContactActions>
                    {links.map((link) => (
                        <Styled.ContactLink
                            key={link.label}
                            href={link.href}
                            target={link.external ? '_blank' : undefined}
                            rel={link.external ? 'noreferrer' : undefined}
                        >
                            <Styled.ContactLinkIcon icon={link.icon}/>
                            {link.label}
                            <Styled.ContactLinkArrow icon={faArrowUpRight}/>
                        </Styled.ContactLink>
                    ))}
                </Styled.ContactActions>
            </Styled.ContactPanel>
        </Styled.ContactBand>
    )
}

export default ContactBand
